import { render } from "./AppAvatar.vue?vue&type=template&id=52d55160&scoped=true&lang=pug"
import script from "./AppAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppAvatar.vue?vue&type=script&setup=true&lang=js"

import "./AppAvatar.vue?vue&type=style&index=0&id=52d55160&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d55160"]])

export default __exports__